export default "__VITE_ASSET__Uh1OzzL6__"